import LabelVue from '@/views/sa/label/label.vue';

const basePath = '/sa/label';
const role = 'sa'; // 角色身份

export const SA_LABEL_INDEX = 'sa-label-index';
export const SA_LABEL_CREATE = 'sa-label-create';
export const SA_LABEL_EDIT = 'sa-label-edit';
export const SA_LABEL_SHOW = 'sa-label-show';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: LabelVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SA_LABEL_INDEX,
      component: () => import(
        /* webpackChunkName: "label" */
        `@/views/${role}/label/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/create`,
      name: SA_LABEL_CREATE,
      component: () => import(
        /* webpackChunkName: "label-create" */
        `@/views/${role}/label/create.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/edit/:tag_id`,
      name: SA_LABEL_EDIT,
      props: true,
      component: () => import(
        /* webpackChunkName: "label-edit" */
        `@/views/${role}/label/edit.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/show`,
      name: SA_LABEL_SHOW,
      props: true,
      component: () => import(
        /* webpackChunkName: "label-edit" */
        `@/views/${role}/label/show.vue`
        ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
